<template>
  <div class="page-box decision-box">
    <div class="decision-head">
      <div class="decision-head-left">地面运行起飞前故障决策</div>
      <div class="decision-head-right">
        <el-select v-model="value" placeholder="当前航班：CSN3482">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
        </el-select>
        <div class="decision-head-bt active"><img src="@/assets/images/yi2.png"/>回到首页</div>
      </div>
    </div>
    <div class="decision-page">
      <div class="decision-left">
        <!--飞机信息-->
        <div class="aircraft-top">
          <div class="message-head">飞机信息</div>
          <div class="message-inputbox">
            <div class="message-input">
              <div class="message-laber">飞机类型</div>
              <el-select>
                <option>123</option>
              </el-select>
            </div>
            <div class="message-input">
              <div class="message-laber">飞机编号(注册号)</div>
              <div class="message-div">B-2350/00712</div>
            </div>
            <div class="message-input">
              <div class="message-laber">航班号</div>
              <div class="message-div">MU5783</div>
            </div>
          </div>
        </div>
        <div class="aircraft-bottom">
          <div class="message-head active">故障信息<p>已选：23-Communications / AIR PACK 1(2) FAILT / 空调组件压气机出口温度受影响</p></div>
          <div class="message-box">
            <div class="message-ul">
              <div class="message-li" v-for="(item,index) in 20">21-AIR Conditioning</div>
            </div>
            <div class="message-ul">
              <div class="message-li" v-for="(item,index) in 20">AIR COND CTL 1(2)-A(B) FAULT</div>
            </div>
            <div class="message-ul">
              <div class="message-li" v-for="(item,index) in 5">空调组件出口温度受影响</div>
            </div>
          </div>
        </div>
      </div>
      <div class="decision-right">
        <div class="aircraft-img">
          <div class="aircraft-head">
            故障照片<span>上传图片/视频</span>
          </div>
          <div class="aircraft-ul">
            <div class="aircraft-li" v-for="(item,index) in 10" :key="index">
              <img src="@/assets/images/gz.png"/>
            </div>
          </div>
        </div>
        <!--红色 active-->
<!--        <div class="aircraft-bt">下一步</div>-->
        <div class="aircraft-bt-box">
          <div class="aircraft-bt1">拒绝模拟机评估申请</div>
          <div class="aircraft-bt2">通过申请并提交至模拟机</div>
        </div>
      </div>
    </div>
    <!--沟通-->
    <el-dialog :visible.sync="dialogTableVisible">
      <div class="communicate-head">正在进行的沟通</div>
      <div class="communicate-ul">
        <div class="communicate-li" v-for="(item,index) in 3">
          <div class="communicate-top">
            <div class="communicate-text">
              <div class="communicate-h">AIR PACK 1(2)(3) REGUL FAULT / 空调组件压气机出口温度受影响AIR </div>
              <div class="communicate-time">2023-02-03</div>
            </div>
            <div class="communicate-bt">参与沟通</div>
          </div>
          <div class="communicate-bottom">
            <div class="communicate-list">
              <div class="communicate-left">航班号</div>
              <div class="communicate-right">CSN6903</div>
            </div>
            <div class="communicate-list">
              <div class="communicate-left">当前参与角色</div>
              <div class="communicate-right">
                <div class="communicate-laber">SOC</div>
                <div class="communicate-laber">MECH</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bt2 pb" style="bottom:24px;">新建沟通</div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "decision",
    data() {
      return{
        dialogTableVisible: false,
      }
    }
  }
</script>

<style lang="less" scoped>
  /deep/.el-select{
    width: 100%;
    .el-input__inner{
      background: #2F323D;
      border-radius: 8px;
      border: none;
      font-size: 16px;
    }
  }
  /deep/.el-dialog{
    background: #262D40;
    margin: inherit;
    margin-top: 0 !important;
    height: 100vh;
    width: 656px;
    overflow: auto;
    .el-dialog__headerbtn{
      width: 28px;
      height: 28px;
      background: url("~@/assets/images/exit.png") no-repeat;
      background-size: 100% 100%;
      top: 42px;
      right: 24px;
      i{
        display: none;
      }
    }
    .el-dialog__header{
      padding: 0;
    }
    .el-dialog__body{
      padding: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/decision/decision.vue